<template>
  <div>
    <div class="archive-head">
      <img src="../../assets/images/logo.png" alt="" />
    </div>
    <div class="img-list">
      <img
        v-for="item in 30"
        :key="item"
        :src="imList[item-1]"
        alt=""
        srcset=""
        @click="routerTo(item-1)"
      />
    </div>
  </div>
</template>
<script>
import img0 from "./map/0.png";
import img1 from "./map/1.png";
import img2 from "./map/2.png";
import img3 from "./map/3.png";
import img4 from "./map/4.png";
import img5 from "./map/5.png";
import img6 from "./map/6.png";
import img7 from "./map/7.png";
import img8 from "./map/8.png";
import img9 from "./map/9.png";
import img10 from "./map/10.png";
import img11 from "./map/11.png";
import img12 from "./map/12.png";
import img13 from "./map/13.png";
import img14 from "./map/14.png";
import img15 from "./map/15.png";
import img16 from "./map/16.png";
import img17 from "./map/17.png";
import img18 from "./map/18.png";
import img19 from "./map/19.png";
import img20 from "./map/20.png";
import img21 from "./map/21.png";
import img22 from "./map/22.png";
import img23 from "./map/23.png";
import img24 from "./map/24.png";
import img25 from "./map/25.png";
import img26 from "./map/26.png";
import img27 from './map/27.png'
import img28 from './map/28.png'
import img29 from './map/29.png'

export default {
  data() {
    return {
      imList: [
        img0,
        img1,
        img2,
        img3,
        img4,
        img5,
        img6,
        img7,
        img8,
        img9,
        img10,
        img11,
        img12,
        img13,
        img14,
        img15,
        img16,
        img17,
        img18,
        img19,
        img20,
        img21,
        img22,
        img23,
        img24,
        img25,
        img26,
        img27,
        img28,
        img29,
      ],
    };
  },
  mounted() {},
  methods: {
      routerTo(id) {
          this.$router.push({
              name: 'mapDetails',
              query: {
                  id
              }
          })
      }
  },
};
</script>
<style lang="less" scoped>
* {
  box-sizing: border-box;
}
.archive-head {
  width: 100%;
  background-color: #0275d8;
  color: white;
  font-size: 16px;
  height: 50px;
  padding: 10px 15px;
  img {
    width: 100px;
  }
}
.img-list {
  padding: 32px;
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  width: 100%;
  img {
    width: 20%;
    padding: 12px;
    cursor: pointer;
  }
}
</style>



// WEBPACK FOOTER //
// src/pages/hotKeywordsMap/index.vue